import { useState, useMemo, useEffect } from 'react';
import useAxios from 'axios-hooks';
import { reactLocalStorage } from 'reactjs-localstorage';
import { PROGRAM_COLUMNS } from 'utils/constants'

export const useProgram = (additionalFilters) => {
  const { organization } = reactLocalStorage.getObject('user');
  const [orgId, setOrgId] = useState(organization?.id);
  const [programId, setProgramId] = useState();
  const [page, setPage] = useState(1);
  const pageSize= 99999999;
  const [updateProgramId, setUpdateProgramId] = useState();

  const onChangePage = (pageNumber) => {
    setPage(pageNumber);
  };

  //Get request
  const [
    { data: dataPrograms, loading: loadingPrograms, error: errorPrograms },
    executePrograms,
  ] = useAxios(
    {
      url: 'programs',
      method: 'POST',
      data: { orgId, paginated: false, page, pageSize, member: true, fieldList: PROGRAM_COLUMNS, ...additionalFilters } },
    { manual: true }
  );

  //Get single promgram request
  const [
    { data: dataDetail, loading: loadingDetail, error: errorDetail },
    executeDetail,
  ] = useAxios({ url: `programs/${programId}` }, { manual: !programId });

  //Update request
  const [
    { data: dataUpdate, loading: loadingUpdate, error: errorUpdate },
    executeUpdate,
  ] = useAxios(
    { url: `programs/${updateProgramId}`, method: 'PUT' },
    { manual: true }
  );

  //Get downloable excel file
  //https://scholarsnapp-program-api-qa.herokuapp.com/api/programs/export?page=1&pageSize=10&letter=&dateField=&from=&to=&enabled=false&inGoApply=false&contest=false&meritBased=false&needBased=false&eligibilityCriteria=&gender=&ethnicity=false&applicationType=&globalSearch=chojun
  const [
    { data: dataDownload, loading: loadingDownload, error: errorDownload },
    executeDownload,
  ] = useAxios(
    {
      url: 'programs/export',
      params: { orgId, paginated: false, page, pageSize, ...additionalFilters },
      responseType: 'blob',
    },
    { manual: orgId !== 0 }
  );

  //Upload file
  const [
    { data: dataImport, loading: loadingImport, error: errorImport },
    executeImport,
  ] = useAxios(
    {
      url: 'programs/bulk-import',
      method: 'POST',
      headers: {
        'Content-Type':
          'multipart/form-data; boundary=----WebKitFormBoundaryslbdi4x6DAXgPrBN',
      },
    },
    { manual: true }
  );

  //Get imports
  const [
    { data: dataImports, loading: loadingImports, error: errorImports },
    executeImports,
  ] = useAxios(
    { url: 'programs/imports', params: { flag: 'import', limit: 10 } },
    { manual: true }
  );

  useEffect(() => {
    executePrograms()
  }, [orgId])

  return useMemo(
    () => ({
      dataPrograms,
      loadingPrograms,
      onChangePage,
      dataDetail,
      loadingDetail,
      errorDetail,
      executeDetail,
      setProgramId,
      programId,
      setUpdateProgramId,
      dataUpdate,
      loadingUpdate,
      errorUpdate,
      executeUpdate,
      executePrograms,
      updateProgramId,
      executeDownload,
      dataDownload,
      loadingDownload,
      dataImport,
      loadingImport,
      errorImport,
      executeImport,
      dataImports,
      loadingImports,
      errorImports,
      executeImports,
      orgId,
      setOrgId,
      errorPrograms,
      errorDownload,
      page,
    }),
    [
      dataPrograms,
      loadingPrograms,
      onChangePage,
      dataDetail,
      loadingDetail,
      errorDetail,
      executeDetail,
      setProgramId,
      programId,
      setUpdateProgramId,
      dataUpdate,
      loadingUpdate,
      errorUpdate,
      executeUpdate,
      executePrograms,
      updateProgramId,
      executeDownload,
      dataDownload,
      loadingDownload,
      dataImport,
      loadingImport,
      errorImport,
      executeImport,
      dataImports,
      loadingImports,
      errorImports,
      executeImports,
      orgId,
      setOrgId,
      errorPrograms,
      errorDownload,
      page,
    ]
  )
};
